import { useTranslation } from 'react-i18next'
import { Form, Wizard } from '@lounge-fe/ui-kit'
import { sizeSchema } from '../schema'
import { StepLayout } from '../StepLayout'
import { StepActions } from '../StepActions'
import { useFittingRoomContext } from '../FittingRoomProvider'

export const BraSize = () => {
  const { t } = useTranslation()
  const { bandSizes, cupSizes } = useFittingRoomContext()
  return (
    <Wizard.Step validationSchema={sizeSchema}>
      <StepLayout
        title={t('fitting_room.bra_size.title')}
        subtitle={t('fitting_room.bra_size.subtitle')}
      >
        <div className="flex gap-4 [&>div]:w-full">
          <Form.Select
            name="bandSize"
            label={t('fitting_room.bra_size.select_bandsize_label')}
            options={bandSizes.map((size) => ({
              label: size.toString(),
              value: size.toString(),
            }))}
            placeholder={t('fitting_room.bra_size.select_placeholder')}
          />
          <Form.Select
            name="cupSize"
            label={t('fitting_room.bra_size.select_cupsize_label')}
            options={cupSizes.map((size) => ({ label: size, value: size }))}
            placeholder={t('fitting_room.bra_size.select_placeholder')}
          />
        </div>
        <StepActions />
      </StepLayout>
    </Wizard.Step>
  )
}
